import GeneralCard from "../../Cards/GeneralCard";
import MarketCard from "../../Cards/MarketCard";
import PricingCard from "../../Cards/PricingCard";
import ManufacturerCard from "../../Cards/ManufacturerCard";
import StatusCard from "../../Cards/StatusCard";
import {useSelector} from "react-redux";
import BundleCard from "../../Cards/BundleCard";
import {userCan} from "../../../../Components/Helpers/Utils";

const GeneralTab = () => {
    const user = useSelector(state => state.user);

    return (
        <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
            <div className="d-flex flex-column gap-7 gap-lg-10">
                <GeneralCard/>
                <MarketCard/>
                <ManufacturerCard/>
                <PricingCard/>
                <BundleCard/>
                {(user?.roles?.includes('Super Admin') || userCan(user?.permissions, 'Product Status Update')) && <StatusCard/>}
            </div>
        </div>
    )
}

export default GeneralTab;